export type ComplianceDefinitionType = {
  rowId: number;
  definitionGuid: string;
  sysOrgGuid: string;
  name: string;
  onboardingJsonString?: string;
  maintenanceJsonString?: string;
  flagsString: string;
  expiryString: string;
  lastUpdated: Date;
  purpose: string;
  status: string;
  security: string;
  primaryOnboardChecklist: string;
  importance: string;
  maintenance: string;
};

export type ComplianceChecklistType = {
  assocWorkflows: string;
  rowId: number;
  listGuid: string;
  sysOrgGuid: string;
  name: string;
  definitionGuidsString: string;
  formJsonString: string;
  lastUpdated: string;
};

export type ComplianceDefinitionDto = {
  Name: string;
  AssocChecklists: string;
  AssocWorkflows: string;
  Status: string;
  Purpose: string;
  Importance: string;
  ItemDefinitionGuid: string;
  LastUpdated: Date;
};

type AssociatedWorkflowDetails = {
  workflowName: string;
  workflowGuid: string;
};

export type ComplianceChecklistDto = {
  AssocWorkflows: AssociatedWorkflowDetails[];
  ListGuid: string;
  Name: string;
  LastUpdated: string;
  Importance: string;
  Status: string;
  Type: string;
  ComplianceType: string;
};

export enum ComplianceStatus {
  Unused = "Unused",
  InUse = "In Use",
  Active = "Active",
  Inactive = "Inactive",
  Archived = "Archived",
}
export enum ComplianceCategory {
  Mandatory = "Mandatory",
  Warning = "Warning",
  Informational = "Informational",
}
